require('./mortgageRequestAnnexConstructions.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
// @ utilities
const { addOrdinal } = require('utilities/stringHelper');
//@ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const MortgageRequestFormattedAddress = require('../mortgageRequestFormattedAddress/mortgageRequestFormattedAddress');
const MortgageRequestFormattedRegistryData = require('../mortgageRequestFormattedRegistryData/mortgageRequestFormattedRegistryData');
// @ constants
const { ESTATES_TYPE_ABBREVIATION } = require('constants/mortgageRequestEstates');

class MortgageRequestAnnexConstructions extends React.Component {
    constructor(props) {
        super(props);

        this.validations = {
            hasLivingPlace: false,
            hasUdifir: false,
            hasRegisterData: false
        };

        this.validateContent = this.validateContent.bind(this);
    }

    buildAddressContent(immEstate) {
        let addressContent;

        if (this.validations.hasLivingPlace) {
            addressContent = (
                <MortgageRequestFormattedAddress
                    immEstate={immEstate}
                    className="mortgage-request-annex-constructions__text"
                />
            );
        }

        return addressContent;
    }

    buildConstructionsItemsContent() {
        const { immAnnexConstructions } = this.props;
        let storeRoomscounter = 0;
        let garagesCounter = 0;

        return immAnnexConstructions.reduce((constructions, immEstate) => {
            this.validateContent(immEstate);
            const type = immEstate.get('propertyType');
            const addressContent = this.buildAddressContent(immEstate);
            const idufirContent = this.buildIdufirContent(immEstate);
            const dataRegistryContent = this.buildDataRegistryContent(immEstate);
            let title, constructionTypeKey, counter;

            if (type === ESTATES_TYPE_ABBREVIATION.TRASTERO) {
                storeRoomscounter += 1;
                constructionTypeKey = 'storageRoom';
                counter = addOrdinal(getLanguage(), Number(storeRoomscounter));
            }

            if (type === ESTATES_TYPE_ABBREVIATION.GARAJE) {
                garagesCounter += 1;
                constructionTypeKey = 'garage';
                counter = addOrdinal(getLanguage(), Number(garagesCounter));
            }

            title = formatText(`mortgageRequestAnnexConstructions-${constructionTypeKey}`, [counter]);

            constructions.push(
                <OKInformativeListItem
                    title={title}
                    compact={true}
                    className="mortgage-request-annex-constructions__item"
                    key={immEstate.get('id')}
                >
                    {addressContent}
                    {idufirContent}
                    {dataRegistryContent}
                </OKInformativeListItem>
            );

            return constructions;
        }, []);
    }

    buildDataRegistryContent(immEstate) {
        let dataRegistryContent;

        if (this.validations.hasRegisterData) {
            dataRegistryContent = (
                <MortgageRequestFormattedRegistryData
                    immEstate={immEstate}
                    className="mortgage-request-annex-constructions__text"
                />
            );
        }

        return dataRegistryContent;
    }

    buildIdufirContent(immEstate) {
        const idufir = immEstate.get('idufir');

        let idufirContent;

        if (this.validations.hasUdifir) {
            idufirContent = (
                <span className="mortgage-request-annex-constructions__text">{idufir}</span>
            )
        }

        return idufirContent;
    }

    cleanValidations() {
        this.validations.hasLivingPlace = false;
        this.validations.hasUdifir = false;
        this.validations.hasRegisterData = false;
    }

    validateContent(immEstate) {
        this.cleanValidations();

        if (immEstate.get('streetType') && immEstate.get('street') && immEstate.get('streetNumber')) {
            this.validations.hasLivingPlace = true;
        } else if (!!immEstate.get('idufir')) {
            this.validations.hasUdifir = true;
        } else if (!this.validations.hasLivingPlace && !this.validations.hasUdifir) {
            this.validations.hasRegisterData = true;
        }
    }

    render() {
        const constructionsItemsContent = this.buildConstructionsItemsContent();

        return (
            <OKInformativeList>
                {constructionsItemsContent}
            </OKInformativeList>
        );
    }
}

MortgageRequestAnnexConstructions.propTypes = {
    immAnnexConstructions: PropTypes.object.isRequired
};

module.exports = MortgageRequestAnnexConstructions;
